import React from "react";
import { Helmet } from "react-helmet";
import Settings from "../../settings";
import { Alerts } from "../generic/Alerts";

interface OwnProps {
    additionalClasses?: string | string[];
    pageTitle?: string;
    style?: React.CSSProperties;
    wrapperId?: string;
}

interface OwnState {
}

export class PublicPage extends React.Component<OwnProps, OwnState> {
    public componentDidMount() {
        if (typeof document !== "undefined") {
            document.body.classList.add("public");
            const css = this.getBodyClasses();
            for (const c of css)
                if (c)
                    document.body.classList.add(c);
        }
    }

    public componentWillUnmount() {
        if (typeof document !== "undefined") {
            document.body.classList.remove("public");
            const css = this.getBodyClasses();
            for (const c of css)
                if (c)
                    document.body.classList.remove(c);
        }
    }

    public render() {
        const style: React.CSSProperties | undefined = this.props.style;
        const helmet = this.props.pageTitle
            ? <Helmet>
                <title>{`${this.props.pageTitle} - ${Settings.ClientName}`}</title>
            </Helmet>
            : null;

        return <div id={this.props.wrapperId || "content"} style={style}>
            {helmet}
            <Alerts />
            {this.props.children}
            <div className="clear"></div>
        </div>;
    }

    private getBodyClasses() {
        return typeof this.props.additionalClasses === "string"
            ? [this.props.additionalClasses]
            : (this.props.additionalClasses || []);
    }
}



// WEBPACK FOOTER //
// ./src/components/page/PublicPage.tsx